import { format } from "date-fns";

export function getOneDayAfter(value: string): string {
  const oneDayAfter = new Date(value + "T00:00:00");
  oneDayAfter.setDate(oneDayAfter.getDate() + 1);
  return format(oneDayAfter, "yyyy-MM-dd");
}

export function getOneDayBefore(value: string): string {
  const oneDayBefore = new Date(value + "T00:00:00");
  oneDayBefore.setDate(oneDayBefore.getDate() - 1);
  return format(oneDayBefore, "yyyy-MM-dd");
}

export function getLast14DaysDateRange(): { startDate: string; endDate: string } {
  const today = new Date();
  const fourteenDaysAgo = new Date(today);
  fourteenDaysAgo.setDate(today.getDate() - 14);
  return {
    startDate: fourteenDaysAgo.toISOString().split("T")[0],
    endDate: today.toISOString().split("T")[0],
  };
}
